import api from '../connectors/Api'

const API = api()

export default {
  namespaced: true,
  state: {
    items: [],
    reports: [],
    members: [],
    fee: null
  },
  mutations: {
    setItems (state, list) {
      state.items = list
    },
    changeItem (state, item) {
      const items = state.items.filter((i) => i.id !== item.id)
      state.items = [...items, item]
    },
    addReport (state, { campaignCpcId, report }) {
      const cpcId = parseInt(campaignCpcId)
      const reports = [...state.reports.filter(i => i.campaignCpcId !== cpcId)]
      reports.push({
        campaignCpcId: cpcId,
        report
      })
      state.reports = reports
    },
    addMembers (state, { campaignCpcId, members }) {
      const cpcId = parseInt(campaignCpcId)
      const membersState = [...state.members.filter(i => i.campaignCpcId !== cpcId)]
      membersState.push({
        campaignCpcId: cpcId,
        members
      })
      state.members = membersState
    },
    setFee (state, fee) {
      state.fee = fee
    }
  },
  getters: {
    getItem: (state) => (id) => {
      const shearchId = parseInt(id)
      return state.items.find((i) => i.id === shearchId)
    },
    getReport: (state) => (id) => {
      const shearchId = parseInt(id)
      const reportItem = state.reports.find((i) => i.campaignCpcId === shearchId)
      return reportItem ? reportItem.report : null
    },
    getMembers: (state) => (id) => {
      const shearchId = parseInt(id)
      const membersItem = state.members.find((i) => i.campaignCpcId === shearchId)
      return membersItem ? membersItem.members : null
    }
  },
  actions: {
    getList ({ commit, state, dispatch }) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.campaignsCpcAdvertiser(token)
            .then((res) => {
              commit('setItems', res.body)
              resolve(state.items)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    },
    getOne ({ commit, state, dispatch }, campaignId) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.getCampaignCpcAdvertiser(token, campaignId)
            .then((res) => {
              commit('changeItem', res.body)
              resolve(res.body)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    },
    add ({ commit, state, dispatch }, data) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.addCampaignsCpcAdvertiser(token, data)
            .then((res) => {
              dispatch('getList')
              resolve(res.body)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    },
    edit ({ commit, state, dispatch }, { id, data }) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.editCampaignsCpcAdvertiser(token, id, data)
            .then((res) => {
              dispatch('getList')
              resolve(res.body)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    },
    deposit ({ commit, state, dispatch }, { id, data }) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.depositCampaignsCpcAdvertiser(token, id, data)
            .then((res) => {
              resolve(res.body.payment_id)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    },
    delete ({ commit, state, dispatch }, id) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.deleteCampaignsCpcAdvertiser(token, id)
            .then((res) => {
              dispatch('getList')
              resolve(res.body)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    },
    getReport ({ commit, state, dispatch }, campaignCpcId) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true })
          .then((token) => {
            API.getCampaignCpcReport(token, campaignCpcId)
              .then((res) => {
                commit('addReport', { campaignCpcId, report: res.body })
                resolve(res.body)
              })
              .catch((e) => {
                reject(e)
              })
          }).catch((e) => {
            reject(e)
          })
      })
    },
    getFee ({ commit, state, dispatch }) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true })
          .then((token) => {
            API.getCampaignCpcFeeAdvertiser(token)
              .then((res) => {
                commit('setFee', res.body.fee)
                resolve(res.body)
              })
              .catch((e) => {
                reject(e)
              })
          }).catch((e) => {
            reject(e)
          })
      })
    },
    getMembers ({ commit, state, dispatch }, campaignCpcId) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true })
          .then((token) => {
            API.getCampaignCpcMembersAdvertiser(token, campaignCpcId)
              .then((res) => {
                commit('addMembers', { campaignCpcId, members: res.body })
                resolve(res.body)
              })
              .catch((e) => {
                reject(e)
              })
          }).catch((e) => {
            reject(e)
          })
      })
    },
    banMember ({ commit, state, dispatch }, { campaignCpcId, memberId, message }) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true })
          .then((token) => {
            API.getBanCampaignCpcMemberAdvertiser(token, memberId, message)
              .then((res) => {
                dispatch('getMembers', campaignCpcId)
                resolve(res.body)
              })
              .catch((e) => {
                reject(e)
              })
          }).catch((e) => {
            reject(e)
          })
      })
    }
  }
}
